var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtUni3N = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 58,
    viewBox: "0 0 126 58",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1E2969"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.622 8.683H62.75v49.315H37.622z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.371 0h20.943v57.998H52.371zM78.286 17.7h19.929v40.297H78.286zM12.276 23.718h22.687v34.279H12.276z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.579 10.99h16.567v47.008H74.579zM7.938 19.617h12.216V58H7.938zM100.889 27.389h15.516v30.609h-15.516z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.711 35.727H126v22.271h-11.289zM0 35.727h11.289v22.271H0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BD8F7E",
    d: "M25.036 35.53h75.927v22.438H25.036z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9C4B9",
    d: "M24.381 55.346h77.235v2.613H24.381z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M100.923 31.454H25.077l-1.35 4.161h78.544zM77.63 37.98h3.535v6.228H77.63z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M81.163 44.21h-3.53l-.206 1.544h3.94z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M3.738 6.226H.204V4.742L3.738 1.31z",
    transform: "translate(77.427 37.98)"
  }), /*#__PURE__*/React.createElement("g", null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M82.547 37.98h3.534v6.228h-3.534z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M86.079 44.21h-3.53l-.204 1.544h3.938z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M3.736 6.226H.202V4.742L3.736 1.31z",
    transform: "translate(82.345 37.98)"
  })), /*#__PURE__*/React.createElement("g", null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M89.054 37.98h3.534v6.228h-3.534z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M92.584 44.21h-3.53l-.204 1.544h3.94z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M3.738 6.226H.204V4.742L3.738 1.31z",
    transform: "translate(88.85 37.98)"
  }), /*#__PURE__*/React.createElement("g", null, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M93.97 37.98h3.534v6.228H93.97z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M97.5 44.21h-3.53l-.204 1.544h3.94z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M3.738 6.226H.204V4.742L3.738 1.31z",
    transform: "translate(93.766 37.98)"
  }))), /*#__PURE__*/React.createElement("g", null, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M77.63 46.79h3.535v6.227H77.63z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M81.163 53.022h-3.53l-.206 1.543h3.94z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M3.738 6.226H.204V4.742L3.738 1.31z",
    transform: "translate(77.427 46.79)"
  }), /*#__PURE__*/React.createElement("g", null, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M82.547 46.79h3.534v6.227h-3.534z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M86.079 53.022h-3.53l-.204 1.543h3.938z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M3.736 6.226H.202V4.742L3.736 1.31z",
    transform: "translate(82.345 46.79)"
  })), /*#__PURE__*/React.createElement("g", null, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M89.054 46.79h3.534v6.227h-3.534z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M92.584 53.022h-3.53l-.204 1.543h3.94z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M3.738 6.226H.204V4.742L3.738 1.31z",
    transform: "translate(88.85 46.79)"
  }), /*#__PURE__*/React.createElement("g", null, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M93.97 46.79h3.534v6.227H93.97z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M97.5 53.022h-3.53l-.204 1.543h3.94z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M3.738 6.226H.204V4.742L3.738 1.31z",
    transform: "translate(93.766 46.79)"
  })))), /*#__PURE__*/React.createElement("g", null, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M28.496 37.98h3.534v6.228h-3.534z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M32.028 44.21h-3.53l-.204 1.544h3.94z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M3.738 6.226H.202V4.742L3.738 1.31z",
    transform: "translate(28.294 37.98)"
  }), /*#__PURE__*/React.createElement("g", null, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M33.412 37.98h3.534v6.228h-3.534z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M36.944 44.21h-3.53l-.204 1.544h3.94z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M3.738 6.226H.202V4.742L3.738 1.31z",
    transform: "translate(33.21 37.98)"
  })), /*#__PURE__*/React.createElement("g", null, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M39.919 37.98h3.534v6.228h-3.534z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M43.45 44.21H39.92l-.204 1.544h3.94z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M3.738 6.226H.204V4.742L3.738 1.31z",
    transform: "translate(39.715 37.98)"
  }), /*#__PURE__*/React.createElement("g", null, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M44.835 37.98h3.534v6.228h-3.534z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M48.367 44.21h-3.532l-.204 1.544h3.94z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M3.738 6.226H.204V4.742L3.738 1.31z",
    transform: "translate(44.631 37.98)"
  }))), /*#__PURE__*/React.createElement("g", null, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M28.496 46.79h3.534v6.227h-3.534z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M32.028 53.022h-3.53l-.204 1.543h3.94z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M3.738 6.226H.202V4.742L3.738 1.31z",
    transform: "translate(28.294 46.79)"
  }), /*#__PURE__*/React.createElement("g", null, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M33.412 46.79h3.534v6.227h-3.534z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M36.944 53.022h-3.53l-.204 1.543h3.94z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M3.738 6.226H.202V4.742L3.738 1.31z",
    transform: "translate(33.21 46.79)"
  })), /*#__PURE__*/React.createElement("g", null, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M39.919 46.79h3.534v6.227h-3.534z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M43.45 53.022H39.92l-.204 1.543h3.94z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M3.738 6.226H.204V4.742L3.738 1.31z",
    transform: "translate(39.715 46.79)"
  }), /*#__PURE__*/React.createElement("g", null, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M44.835 46.79h3.534v6.227h-3.534z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M48.367 53.022h-3.532l-.204 1.543h3.94z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M3.738 6.226H.204V4.742L3.738 1.31z",
    transform: "translate(44.631 46.79)"
  }))))), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C5",
    opacity: 0.55,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1.31 4.168h75.927v1.544H1.31z",
    transform: "translate(23.726 31.454)"
  }), /*#__PURE__*/React.createElement("g", null, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "m48.688 28.748 14.31-11.738L77.31 28.748z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9BDB3",
    d: "M74.781 57.987H51.22V28.744l11.78-9.71 11.782 9.71z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#BD8F7E",
    d: "M54.491 44.911H71.51v13.078H54.491z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9C9B9B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M5.803 28.032v12.945h.785V28.495h15.446v12.482h.787V28.032z",
    transform: "translate(48.688 17.01)"
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9DFD1",
    d: "M50.563 43.063h24.873v1.979H50.563z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M67.73 50.7c-.091-1.861-2.173-3.347-4.731-3.347s-4.64 1.488-4.731 3.347l-.005 7.279h9.471l-.004-7.28z",
    fill: "#9A5238"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.738 10.625H9.47l-.004-7.278C9.375 1.487 7.294 0 4.737 0v10.625z",
    fill: "#7C7B7B",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(58.263 47.353)"
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M65.619 26.205A2.628 2.628 0 0 1 63 28.845a2.628 2.628 0 0 1-2.618-2.64 2.628 2.628 0 0 1 2.618-2.639 2.628 2.628 0 0 1 2.618 2.64z",
    fill: "#BD8F7E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M65.064 26.205A2.07 2.07 0 0 1 63 28.285a2.07 2.07 0 0 1-2.063-2.08c0-1.149.923-2.08 2.063-2.08 1.14 0 2.063.931 2.063 2.08z",
    fill: "#F9DFD1"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M53.855 31.655h3.534v8.604h-3.534z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#C09484",
    d: "M57.387 40.263h-3.53l-.204 1.544h3.938z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929191",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M3.736 8.601H.202V7.118l3.534-3.433z",
    transform: "translate(53.653 31.655)"
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M58.772 31.655h3.534v8.604h-3.534z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#C09484",
    d: "M62.304 40.263h-3.53l-.204 1.544h3.938z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929191",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M3.736 8.601H.202V7.118l3.534-3.433z",
    transform: "translate(58.57 31.655)"
  }), /*#__PURE__*/React.createElement("g", null, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M63.688 31.655h3.534v8.604h-3.534z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#C09484",
    d: "M67.22 40.263h-3.53l-.204 1.544h3.938z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929191",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M3.736 8.601H.202V7.118l3.534-3.433z",
    transform: "translate(63.486 31.655)"
  })), /*#__PURE__*/React.createElement("g", null, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    d: "M68.604 31.656h3.534v8.604h-3.534z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#C09484",
    d: "M72.136 40.263h-3.53l-.204 1.544h3.938z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#BD8F7E",
    d: "M68.61 32.76h3.532l.205-1.544h-3.94zM63.694 32.76h3.532l.204-1.544h-3.94zM58.778 32.76h3.532l.204-1.544h-3.94zM53.862 32.76h3.532l.204-1.544h-3.94z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#929191",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M18.48 9.041h-3.534V7.557l3.535-3.432z",
    transform: "translate(53.658 31.216)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M2.533 12.5 14.31 2.786l11.778 9.714.004-.778-11.782-9.712-11.78 9.712z",
    transform: "translate(48.688 17.01)"
  }), /*#__PURE__*/React.createElement("g", null, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9DFD1",
    d: "M71.203 54.33h3.927v3.658h-3.927zM71.215 45.057h3.927v3.053h-3.927z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9C9B9B",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M0 0h3.927v3.053H0z",
    transform: "translate(71.215 45.057)"
  }), /*#__PURE__*/React.createElement("g", null, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9DFD1",
    d: "M50.857 54.33h3.927v3.658h-3.927zM50.87 45.057h3.927v3.053H50.87z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9C9B9B",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M0 0h3.927v3.053H0z",
    transform: "translate(50.87 45.057)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M44.678 13.805h1.53V58h-1.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7 18.2c-2.666 1.83-5.334-1.831-8 0v-4.577c2.666-1.831 5.334 1.83 8 0V18.2z",
    fill: "#F6C760"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m16.73 52.797-.382-.174c-.226.504-.876 1.662-1.62 2.082-.207.081-.268-.155-.281-.33v-1.96h-.755v1.972c-.015.185-.087.42-.32.296-.726-.44-1.36-1.563-1.581-2.06l-.383.174c.038.085.823 1.824 1.927 2.345.246.127.33.504.357.768V58h.755v-2.073c.025-.268.108-.658.363-.783h-.008c1.103-.519 1.888-2.257 1.926-2.345l.003-.002z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.064 49.78a2.151 2.151 0 0 0-2.124-2.455h-.037a2.142 2.142 0 0 0-1.835-1.042c-.778 0-1.458.418-1.835 1.042h-.036a2.151 2.151 0 0 0-2.124 2.455c-.377.39-.61.922-.61 1.51 0 1.194.959 2.16 2.143 2.16.634 0 1.203-.276 1.597-.718a2.117 2.117 0 0 0 1.73 0c.394.442.962.719 1.598.719a2.151 2.151 0 0 0 2.143-2.162c0-.587-.232-1.119-.61-1.509z",
    fill: "#80C134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.53 53.028a2.14 2.14 0 0 1-1.596-.718 2.117 2.117 0 0 1-1.731 0 2.129 2.129 0 0 1-1.597.718 2.148 2.148 0 0 1-2.133-1.95 2.151 2.151 0 0 0 2.133 2.373c.634 0 1.203-.277 1.597-.719a2.117 2.117 0 0 0 1.73 0c.394.442.962.719 1.598.719a2.151 2.151 0 0 0 2.132-2.374 2.15 2.15 0 0 1-2.132 1.951z",
    fill: "#528C10"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m107.59 50.541-.506-.23c-.298.67-1.161 2.203-2.146 2.76-.274.107-.355-.206-.372-.437v-2.599h-1v2.614c-.02.244-.117.557-.423.39-.965-.581-1.803-2.073-2.094-2.73l-.506.23c.05.114 1.09 2.418 2.554 3.107.327.169.435.666.472 1.016v3.332h.999v-3.31c.034-.354.142-.873.483-1.038h-.011c1.463-.689 2.503-2.993 2.554-3.107l-.004.002z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.357 46.545c.017-.127.027-.257.027-.388 0-1.582-1.271-2.864-2.84-2.864h-.05a2.835 2.835 0 0 0-2.43-1.383 2.83 2.83 0 0 0-2.43 1.383h-.05c-1.569 0-2.84 1.282-2.84 2.864 0 .13.008.261.027.388a2.868 2.868 0 0 0-.808 2c0 1.582 1.272 2.865 2.841 2.865.84 0 1.595-.37 2.116-.952a2.804 2.804 0 0 0 2.292 0 2.824 2.824 0 0 0 2.116.952c1.57 0 2.84-1.283 2.84-2.865 0-.778-.307-1.483-.807-2h-.004z",
    fill: "#80C134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.324 50.85c-.84 0-1.595-.369-2.116-.952a2.804 2.804 0 0 1-2.292 0 2.824 2.824 0 0 1-2.116.952 2.848 2.848 0 0 1-2.826-2.586 3.067 3.067 0 0 0-.013.281c0 1.582 1.272 2.865 2.841 2.865.84 0 1.595-.37 2.116-.952a2.804 2.804 0 0 0 2.292 0 2.824 2.824 0 0 0 2.116.952c1.57 0 2.84-1.283 2.84-2.865 0-.094-.003-.188-.012-.28-.14 1.45-1.352 2.585-2.826 2.585h-.004z",
    fill: "#528C10"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m25.336 49.727-.566-.256c-.331.746-1.292 2.455-2.392 3.077-.306.12-.397-.23-.414-.487v-2.894h-1.115v2.914c-.023.272-.13.62-.472.435-1.076-.648-2.01-2.31-2.334-3.042l-.566.255c.057.128 1.214 2.697 2.845 3.462.366.189.487.744.527 1.134V58h1.115v-3.651c.038-.395.16-.971.538-1.158h-.011c1.63-.767 2.79-3.336 2.845-3.464z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.305 45.271c.02-.141.03-.285.03-.433 0-1.762-1.418-3.192-3.166-3.192h-.053a3.156 3.156 0 0 0-2.71-1.54 3.161 3.161 0 0 0-2.709 1.54h-.053c-1.748 0-3.166 1.43-3.166 3.192 0 .146.01.292.03.433a3.194 3.194 0 0 0-.902 2.23c0 1.762 1.419 3.192 3.166 3.192a3.15 3.15 0 0 0 2.359-1.06 3.141 3.141 0 0 0 2.556 0 3.147 3.147 0 0 0 2.358 1.06c1.748 0 3.166-1.43 3.166-3.192 0-.868-.344-1.653-.902-2.23h-.004z",
    fill: "#80C134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.04 50.067a3.15 3.15 0 0 1-2.358-1.06 3.141 3.141 0 0 1-2.556 0 3.147 3.147 0 0 1-2.358 1.06c-1.643 0-2.996-1.265-3.151-2.881-.01.103-.015.208-.015.313 0 1.762 1.418 3.192 3.166 3.192a3.15 3.15 0 0 0 2.358-1.06 3.141 3.141 0 0 0 2.556 0 3.147 3.147 0 0 0 2.359 1.06c1.747 0 3.166-1.43 3.166-3.192 0-.105-.005-.21-.015-.313-.155 1.616-1.508 2.881-3.151 2.881z",
    fill: "#528C10"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtUni3N);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-uni-3n.9f10eee8a072f596dedaa16ac95f2fa5.svg";